import { render, staticRenderFns } from "./EditBrief.vue?vue&type=template&id=61e66e11&scoped=true&"
import script from "./EditBrief.vue?vue&type=script&lang=js&"
export * from "./EditBrief.vue?vue&type=script&lang=js&"
import style0 from "./EditBrief.vue?vue&type=style&index=0&id=61e66e11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e66e11",
  null
  
)

export default component.exports